<template>
    <div class="patients-new">
        <div class="patients_header">
            <h1>Список пациентов</h1>
            <div class="header-nav">
                <div class="nav-btnContainer">
                    <v-btn type="button" @click.prevent="changeFlag({ name: 'dialog', value: true })">
                        <svg class="btn-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.7958 5C3.7958 3.34315 5.13895 2 6.7958 2C8.45266 2 9.7958 3.34315 9.7958 5C9.7958 6.65685 8.45266 8 6.7958 8C5.13895 8 3.7958 6.65685 3.7958 5ZM6.7958 0C4.03438 0 1.7958 2.23858 1.7958 5C1.7958 7.76142 4.03438 10 6.7958 10C9.55723 10 11.7958 7.76142 11.7958 5C11.7958 2.23858 9.55723 0 6.7958 0ZM6.7958 12C5.25486 12 3.75698 12.5085 2.53447 13.4465C1.31196 14.3846 0.433147 15.6998 0.0343224 17.1883C-0.10862 17.7217 0.207963 18.2701 0.741429 18.413C1.27489 18.556 1.82323 18.2394 1.96617 17.7059C2.25105 16.6427 2.87878 15.7033 3.752 15.0332C4.62522 14.3632 5.69513 14 6.7958 14C7.89647 14 8.96639 14.3632 9.83961 15.0332C10.7128 15.7033 11.3406 16.6427 11.6254 17.7059C11.7684 18.2394 12.3167 18.556 12.8502 18.413C13.3836 18.2701 13.7002 17.7217 13.5573 17.1883C13.1585 15.6998 12.2796 14.3846 11.0571 13.4465C9.83463 12.5085 8.33674 12 6.7958 12ZM15.7958 6C16.3481 6 16.7958 6.44772 16.7958 7V9H18.7958C19.3481 9 19.7958 9.44772 19.7958 10C19.7958 10.5523 19.3481 11 18.7958 11H16.7958V13C16.7958 13.5523 16.3481 14 15.7958 14C15.2435 14 14.7958 13.5523 14.7958 13V11H12.7958C12.2435 11 11.7958 10.5523 11.7958 10C11.7958 9.44771 12.2435 9 12.7958 9H14.7958V7C14.7958 6.44772 15.2435 6 15.7958 6Z"/>
                        </svg>
                        <span> Добавить</span>
                    </v-btn>
                    <v-btn type="button" @click.prevent="showImport()">
                        Импорт
                    </v-btn>
                </div>
                <div class="tasks_search">
                <input
                    placeholder="Поиск"
                    id="search_tasks"
                    v-model="search"
                    @input="searchF(search)"
                    class="tasks_search-input"
                />
                <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667C15.8333 10.7068 15.3111 12.125 14.4339 13.2538L17.6726 16.4941L16.4941 17.6726L13.2538 14.4339C12.125 15.3111 10.7068 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5ZM9.16667 4.16667C6.40524 4.16667 4.16667 6.40524 4.16667 9.16667C4.16667 11.9281 6.40524 14.1667 9.16667 14.1667C11.9281 14.1667 14.1667 11.9281 14.1667 9.16667C14.1667 6.40524 11.9281 4.16667 9.16667 4.16667Z" fill="#AAAEB7"/>
                </svg>
            </div>
            </div>
        </div>

        <div class="patients_body">
            <div class="body-item" v-for="(el, ind) in patients" :key="'A' + ind">
                <div class="item-name">
                    <img :src="getPhotoUrl(el)" class="name-icon" alt="icon">

                    <div class="name-txtContainer">
                        <span>{{ el.fio }}</span>
                        <div class="gender-container">
                            <span>Пол:</span>
                            <div
                                class="gender"
                                :class="{
                                    'male': el.gender === 0,
                                    'female':el.gender === 1
                                }">
                                    {{ el.gender === 0 ? 'М' : 'Ж' }}
                                </div>
                        </div>
                    </div>
                </div>

                <div class="item-info">
                    <div class="info-container">
                        <div class="info-wrap">
                            <span>Дата рождения:</span>
                            <span>{{ el.birthday | filterBirthday }} ({{ el.birthday | calculateAge }})</span>
                        </div>
                        <div class="info-wrap">
                            <span>Количество эпизодов жизни:</span>
                            <span>{{ el.episodeCount }}</span>
                        </div>
                    </div>

                    <div class="info-btn-container">
                        <v-btn :loading="el.loadingEdite" class="info-btn" type="button" @click="editeItems(el)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <g clip-path="url(#clip0_4144_27533)">
                                <path d="M3.72165 10.2345L3.72164 10.2345C3.70856 10.2476 3.69508 10.261 3.68127 10.2747C3.5291 10.426 3.33649 10.6174 3.1996 10.8592L4.0698 11.3519L3.1996 10.8592C3.06272 11.101 2.99765 11.3646 2.94624 11.5729C2.94158 11.5918 2.93702 11.6103 2.93254 11.6282L2.23197 14.4305C2.22917 14.4417 2.22625 14.4534 2.22323 14.4654C2.18641 14.6118 2.1354 14.8148 2.11783 14.9944C2.09762 15.2011 2.09093 15.653 2.45971 16.0218C2.82849 16.3906 3.28045 16.3839 3.48714 16.3637C3.66675 16.3461 3.86967 16.2951 4.01615 16.2583C4.02816 16.2553 4.03978 16.2523 4.05099 16.2495L6.85326 15.549C6.8712 15.5445 6.88966 15.5399 6.90857 15.5353C7.11687 15.4839 7.38054 15.4188 7.6223 15.2819L7.1296 14.4117L7.62231 15.2819C7.86407 15.145 8.05552 14.9524 8.20677 14.8002C8.2205 14.7864 8.2339 14.7729 8.24698 14.7599L15.7744 7.23244C15.7872 7.2196 15.8001 7.20678 15.8129 7.19398C16.1128 6.89417 16.4043 6.60281 16.6123 6.33013C16.8468 6.02274 17.0673 5.62478 17.0673 5.11112C17.0673 4.59745 16.8468 4.19949 16.6123 3.8921C16.4043 3.61942 16.1128 3.32806 15.8129 3.02826C15.8001 3.01545 15.7872 3.00263 15.7744 2.9898L15.4917 2.70711L14.7975 3.40136L15.4917 2.70711C15.4789 2.69426 15.466 2.68143 15.4532 2.66861C15.1534 2.3687 14.8621 2.07723 14.5894 1.86919C14.282 1.63466 13.8841 1.41421 13.3704 1.41421C12.8567 1.41421 12.4588 1.63466 12.1514 1.86919C11.8787 2.07723 11.5873 2.36871 11.2875 2.66863C11.2747 2.68145 11.2619 2.69427 11.2491 2.70711L3.72165 10.2345Z" stroke="white" stroke-width="2"/>
                                <path d="M11 3.48145L15 7.48145" stroke="white" stroke-width="2"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_4144_27533">
                                    <rect width="18" height="18" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                            <span class="btn-txt">Редактировать</span>
                        </v-btn>
                        <div class="btn-wrap">
                            <v-btn @click="deleteItem(el)" class="btn-del">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="19" viewBox="0 0 24 24" fill="none">
                                    <path d="M9.28323 1.41946C9.2796 1.42604 9.27646 1.43288 9.27385 1.43993L8.01208 4.85H2.95455C2.34559 4.85 1.85 5.34024 1.85 5.94737C1.85 6.55449 2.34559 7.04474 2.95455 7.04474H4.23636V22.0526C4.23636 22.6598 4.73195 23.15 5.34091 23.15H19.6591C20.268 23.15 20.7636 22.6598 20.7636 22.0526V7.04474H22.0455C22.6544 7.04474 23.15 6.55449 23.15 5.94737C23.15 5.34024 22.6544 4.85 22.0455 4.85H16.9942L15.7619 1.44799C15.7594 1.441 15.7563 1.43421 15.7528 1.42767C15.5601 1.07155 15.1861 0.85 14.78 0.85H10.2516C9.84876 0.85 9.47739 1.06793 9.28323 1.41946ZM11.6955 10.6842C11.6955 10.0771 11.1999 9.58684 10.5909 9.58684C9.98195 9.58684 9.48636 10.0771 9.48636 10.6842V16.8421C9.48636 17.4492 9.98195 17.9395 10.5909 17.9395C11.1999 17.9395 11.6955 17.4492 11.6955 16.8421V10.6842ZM15.5136 10.6842C15.5136 10.0771 15.018 9.58684 14.4091 9.58684C13.8001 9.58684 13.3045 10.0771 13.3045 10.6842V16.8421C13.3045 17.4492 13.8001 17.9395 14.4091 17.9395C15.018 17.9395 15.5136 17.4492 15.5136 16.8421V10.6842ZM10.9342 3.04474H14.0913L14.531 4.85H10.4855L10.9342 3.04474ZM18.5545 20.9553H6.44545V7.04474H18.5545V20.9553Z" fill="#4854FE" stroke="white" stroke-width="0.3" stroke-linejoin="round"/>
                                </svg>
                            </v-btn>
                            <v-tooltip bottom color="#4854FE">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" @click="exportPatient(el)" :loading="el.loadingExport" class="export">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none">
                                            <path d="M7 10L12 5M12 5L17 10M12 5L12 14" stroke="#4854FE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M5 16L5 17C5 18.1046 5.89543 19 7 19L17 19C18.1046 19 19 18.1046 19 17V16" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                                        </svg>
                                    </v-btn>
                                </template>
                                <span>Экспорт данных пациента</span>
                            </v-tooltip>
                        </div>
                    </div>
                </div>
            </div>

            <div class="no-data" v-if="patients.length === 0">
                Не найдено подходящих записей...
            </div>
        </div>

        <div class="data-footer">
            <div class="pagination">
                <span>Cтраница:</span>
                <div class="pagination_prev" @click.prevent="prevPage(params)">
                    <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="shape" fill-rule="evenodd" clip-rule="evenodd" d="M0.269108 8.64968L6.70064 15.0812L8 13.7818L2.21815 8L8 2.21815L6.70064 0.918787L0.269108 7.35031C-0.0897023 7.70912 -0.0897023 8.29087 0.269108 8.64968Z" fill="#878A91"/>
                    </svg>
                </div>
                <div
                    v-for="(item, key) in totalCount"
                    :key="key"
                    class="pagination_number"
                    :class="{ 'active': item === params.currentPage+1 }"
                    @click.prevent="nextTo(item-1, params)"
                >
                    {{ item }}
                </div>
                <div class="pagination_next" @click.prevent="nextPage(params)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.73089 8.64965L1.29936 15.0812L-5.6797e-08 13.7818L5.78185 7.99997L-5.62262e-07 2.21812L1.29936 0.918756L7.73089 7.35028C8.0897 7.70909 8.0897 8.29084 7.73089 8.64965Z" fill="#878A91"/>
                    </svg>
                </div>
            </div>
            <div class="select-list">
                <span>Выводить:</span>
                <div class="select-list_drop">
                    <v-select
                        :items="pageSizes"
                        @change="updatePageSize(params.pageSize, params)"
                        outlined
                        hide-details
                        item-text="name"
                        item-value="size"
                        dense
                        v-model="params.pageSize"
                    />
                </div>
            </div>
        </div>


        <v-dialog
            v-model="getDialog"
            :max-width="771"
            scrollable
            persistent
            content-class="dialog-container"
        >
            <CreatePatient />
        </v-dialog>

        <v-dialog
            v-model="getDialogEpisode"
            scrollable
            fullscreen
            persistent
            content-class="dialog-container"
        >
            <AddEpisodeLife v-if="getDialogEpisode" />
        </v-dialog>

        <v-dialog
            v-model="getDialogImport"
            :max-width="485"
            scrollable
            persistent
            content-class="dialog-container"
        >
            <ImportPatients v-show="clickShowImport" @closeImport = "closeImport()"/>
        </v-dialog>
    </div>
</template>

<script>
import './index.scss'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import debounce from 'lodash.debounce'
import CreatePatient from './CreatePatients/index.vue'
import AddEpisodeLife from './AddEpisodeLife/index.vue'
import ImportPatients from './ImportPatients/index.vue'

export default {
    name: 'Patients',
    components: {
        CreatePatient,
        AddEpisodeLife,
        ImportPatients
    },
    computed:{
        ...mapGetters({
            apiUrl: 'apiUrl',
            apiImg: 'apiImg',
            getDialog: 'patient/getDialog',
            getDialogEpisode: 'patient/getDialogEpisode',
            getDialogImport: 'patient/getDialogImport'
        })
    },
    watch: {
        getDialog(val) {
            if(!val) this.get(this.params);
        }
    },
    data() {
        return {
            clickShowPatient: true,
            clickShowEpLife: false,
            clickShowImport: false,
            search: null,
            patients: [],
            totalCount: 0,
            allItemsSize: 9,
            pageSizes: [
                { name: '5', size: 5 },
                { name: '10', size: 10 },
                { name: '15', size: 15 },
                { name: 'Все', size: 9 }
            ],
            declension: ['год', 'года', 'лет'],
            params: {
                filters: [],
                sortOption: {
                    fieldName: 'fio',
                    sortType: 1
                },
                pageSize: 10,
                currentPage: 0,
                useANDoperator: true,
                columns: []
            }
        }
    },
    methods: {
        ...mapMutations({
            changeFlag: 'patient/changeFlag'
        }),
        ...mapActions({
            getPatient: 'patient/getPatient'
        }),
        getPhotoUrl(student) {
            if (student.logoUrl) {
                return `${this.apiImg}${student.logoUrl}`;
            }

            if (student.gender === 0) {
                return require('@/assets/img/avatar-boy.png');
            }

            if (student.gender === 1) {
                return require('@/assets/img/avatar-girl.png');
            }

            return require('@/assets/img/default-profile-image.png');
        },
        showAddEp() {
            this.clickShowEpLife = true
            this.clickShowPatient = false
        },
        showImport() {
            this.changeFlag({ name: 'dialogImport', value: true })
            this.clickShowPatient = false
            this.clickShowImport = true
        },
        closeImport() {
            this.changeFlag({ name: 'dialogImport', value: false })
            this.clickShowImport = false
            this.clickShowPatient = true
            this.get(this.params)
        },
        prevPage(params) {
            if (params.currentPage > 0) {
                params.currentPage--;
                this.get(params);
            }
        },
        nextPage(params) {
            if (params.currentPage < (this.totalCount - 1)) {
                params.currentPage++;
                this.get(params);
            }
        },
        nextTo(page, params) {
            if(page === params.currentPage) {
                return;
            }
            params.currentPage = page;
            this.get(params);
        },
        updatePageSize(size, params) {
            if(size === 'Все') size = 999;

            params.currentPage = 0;
            params.pageSize = size;
            this.get(params);
        },
        searchF: debounce( function (text) {
            if (text && text.length > 0) {
                this.params.filters = [
                    {
                        fieldName: 'fio',
                        filterType: 2,
                        filterValueType: 1,
                        value1: text,
                        value2: '',
                        values: []
                    }
                ];
            } else {
                this.params.filters = [];
            }

            this.params.currentPage = 0;
            this.get(this.params);
        }, 1000),
        get(params) {
            this.$http.post(`${this.apiUrl}Patient/GetAll`, params)
                .then((res) => {
                    for (let i = 0; i < res.data.data.length; i++) {
                        this.$set(res.data.data[i], 'loadingEdite', false)
                        this.$set(res.data.data[i], 'loadingExport', false)
                    }
                    this.patients = res.data.data
                    this.totalCount = params.pageSize ? Math.ceil(res.data.totalRecords / params.pageSize) : 1;
                })
                .catch((error) => {
                    // console.log(error.response);
                })
        },
        editeItems(item) {
            item.loadingEdite = true;

            this.getPatient(item.id)
                .then(() => {
                    this.changeFlag({ name: 'dialog', value: true });
                    item.loadingEdite = false;
                })
        },
        deleteItem(el){
            if(confirm("Вы действительно хотите удалить пациента?"))
            this.$http.delete(`${this.apiUrl}Patient/MarkAsDelete?patientId=${el.id}`)
                .then((res) => {
                    if (res.data.success) {
                        this.get(this.params);
                    } else if (res.data.userMessage) {
                        alert(res.data.userMessage);
                    }
                });
        },
        exportPatient(item) {

            item.loadingExport = true;

            this.$http.post(`${this.apiUrl}Patient/ExportXml?id=${item.id}`, { responseType: 'blob' })
                .then((result) => {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(new Blob([result.data]));

                    let fileName = decodeURI(result.headers['content-disposition'].split('filename*=')[1].split("''")[1]);
                    link.setAttribute('download', fileName);

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    item.loadingExport = false;
                });
        }
    },
    created() {
        this.get(this.params);
    }
}
</script>
